// Example usage:
// const trimmedValue = removeExtraLineSpaces(originalValue);

export const removeExtraLineSpaces = (text) => {
  // Replace occurrences of two newline characters with a single newline character
  return text?.replace(/\n\s*\n/g, "\n");
};
